
















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppFavoriteIcon from '~/components/partials/App/AppFavoriteIcon.vue';
import { useFavoriteButton } from '~/composables/useFavoriteButton';
import { FavoriteType } from '~/types/common/user';
import { FavoriteTypes } from '~/enums';

type Size = 'small' | 'large';

export default defineComponent({
  components: {
    AppFavoriteIcon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<Size>,
      default: 'small',
    },
    // 親商品コード
    favoriteCode: {
      type: String,
      required: true,
    },
    type: {
      type: String as PropType<FavoriteType>,
      default: FavoriteTypes.ITEM,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    isHorizontalDisplay: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { onClickFavoriteButton, syncedActive } = useFavoriteButton(props);

    return {
      syncedActive,
      onClickFavoriteButton,
    };
  },
});
